/**
 * API 错误事件总线
 * request.js 拦截器通过它广播错误，MainLayout 监听并展示全局 Alert
 */
const listeners = new Set();

const apiError = {
  /**
   * 订阅错误事件
   * @param {(msg: string) => void} fn
   * @returns {() => void} unsubscribe
   */
  on(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  /**
   * 发布错误事件
   * @param {string} message
   */
  emit(message) {
    listeners.forEach((fn) => {
      try {
        fn(message);
      } catch (e) {
        console.error('apiError listener error:', e);
      }
    });
  },

  /**
   * 清除当前全局错误（Modal 等本地处理错误后调用，防止重复显示）
   */
  clear() {
    listeners.forEach((fn) => {
      try {
        fn('');
      } catch (e) {
        console.error('apiError listener error:', e);
      }
    });
  },
};

export default apiError;
